import { Container, YStack, ScrollView, XStack, Spinner } from '@my/ui'
import React from 'react'
import { MainLayout, Meta, NoAccess, SectionTitle } from 'app/components'
import { GroupCardBasic } from '../../containers'
import { User } from 'app/types'
import { ModeratedUserGroupsQueryOutput } from '../../queries'
import { RefreshControl } from 'react-native'
import { GroupNoResults } from '../../components'

export interface ModeratedGroupsScreenProps {
  HeaderComponent?: React.ReactNode
  user: User | null
  userModeratedGroups: ModeratedUserGroupsQueryOutput['userModeratedGroups']['docs']
  userModeratedGroupsLoading: boolean

  refreshing: boolean
  onPullToRefresh: () => void
}

export function ModeratedGroupsScreen(props: ModeratedGroupsScreenProps) {
  return (
    <MainLayout>
      <Meta title="Groups" />
      {props.HeaderComponent && props.HeaderComponent}
      <ScrollView
        refreshControl={
          <RefreshControl refreshing={props.refreshing} onRefresh={props.onPullToRefresh} />
        }
      >
        {props.user && (
          <Container
            flex={1}
            ai="flex-start"
            jc="flex-start"
            spaceTop
            spaceBottom
            gap="$6"
            $gtMd={{
              gap: '$8',
            }}
          >
            {/* User moderated groups */}
            <Container size="sm" gutter>
              <YStack gap="$3.5" w="100%" flexShrink={1}>
                <SectionTitle>Groups you moderate</SectionTitle>

                {props.userModeratedGroups.length === 0 && (
                  <GroupNoResults
                    title="You are not a moderator of any groups yet"
                    description="Join and contribute to groups to become a moderator"
                  />
                )}

                {props.userModeratedGroups.length > 0 &&
                  props.userModeratedGroups.map((userGroup) => (
                    <GroupCardBasic
                      key={`Moderated:${userGroup.group.id}`}
                      id={userGroup.group.id}
                      name={userGroup.group.name}
                      totalMembers={userGroup.group.totalMembers || 0}
                      visibility={userGroup.group.visibility}
                      profileImage={{
                        url: userGroup.group.profileImage?.sizes?.medium?.url || '',
                      }}
                      href={`/groups/${userGroup.group.id}`}
                    />
                  ))}

                {props.userModeratedGroupsLoading && !props.userModeratedGroups && (
                  <XStack w="100%" jc="center" ai="center" h={100}>
                    <Spinner color="$black" />
                  </XStack>
                )}
              </YStack>
            </Container>
          </Container>
        )}
        {!props.user && (
          <Container flex={1} py="$3.5" gap="$2" gutter size="sm">
            <NoAccess title="You must Sign In or Sign Up to Student Saviour to access your groups" />
          </Container>
        )}
      </ScrollView>
    </MainLayout>
  )
}
